export default __webpack_public_path__ + "static/media/pushpin.b1fd7f50.svg";